import { useState, useEffect } from 'react'
import { apiClient } from '../api/client'
import type { SavedAlbum } from '../api/types'

type UseSavedAlbumsResult = {
  albums: SavedAlbum[]
  loading: boolean
  error: string | null
  refresh: () => void
}

/**
 * 保存済みアルバム一覧を取得するカスタムフック
 */
export function useSavedAlbums(): UseSavedAlbumsResult {
  const [albums, setAlbums] = useState<SavedAlbum[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchSavedAlbums = async () => {
    setLoading(true)
    setError(null)

    try {
      const response = await apiClient.getSavedAlbums()
      setAlbums(response.albums)
    } catch (err) {
      console.error('Failed to fetch saved albums:', err)
      setError(err instanceof Error ? err.message : 'Failed to fetch saved albums')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchSavedAlbums()
  }, [])

  return {
    albums,
    loading,
    error,
    refresh: fetchSavedAlbums,
  }
}
